export default "__VITE_ASSET__DYiEv5ho__"